import type { RouteLocationNormalized } from 'vue-router'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '~/composables/translate/translations'
import { CITIES, DEFAULT_CITY } from '~/composables/city'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  const pathParams = from.path.match(/\/(\w+)\/([^\/]+)\/?/) || []

  if (to.matched.length === 0) {
    const redirectUrl = `/${getLanguage(pathParams)}/${getCity(pathParams)}/category/`

    return navigateTo({
      path: redirectUrl,
      // keep query parameters on redirect to category component
      query: to.query,
    })
  }
})

const LANGUAGES_ALLOWED: Set<string> = new Set(SUPPORTED_LOCALES.map(l => l.toString()))
const CITIES_ALLOWED: Set<string> = new Set(CITIES.map(c => c.id))

function getCity(pathParams: any[]): string {
  const city: string = pathParams[2] || DEFAULT_CITY
  return CITIES_ALLOWED.has(city) ? city : DEFAULT_CITY
}

function getLanguage(pathParams: any[]): string {
  const lang: string = pathParams[1] || DEFAULT_LOCALE
  return LANGUAGES_ALLOWED.has(lang) ? lang : DEFAULT_LOCALE
}
